import { Component, OnInit, OnDestroy } from '@angular/core';

import { ContentJobsService } from './content-jobs.service';
import { PaneControlService } from './../../services/pane-control.service';

@Component({
	selector: 'app-content-jobs',
	templateUrl: './content-jobs.component.html',
	styleUrls: ['./content-jobs.component.css']
})
export class ContentJobsComponent implements OnInit, OnDestroy {

	constructor(
		private jobsService: ContentJobsService,
		private paneService: PaneControlService
	) { }

	ngOnInit() {
		// Tell paneControl current pane is switched to jobs, so that the highlighted menu item can change to jobs
		this.paneService.currPane.next({
			paneType: 'jobs'
		});
	}

	ngOnDestroy() {
		// Wizard mode off
		this.jobsService.wizard = 'off';
	}

}
